/* eslint-disable no-eval */
/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable react-hooks/exhaustive-deps */
import { useState, useEffect } from "react";
import axios from "axios";
import { ImSpinner8 } from "react-icons/im";
import SweetAlert2 from "react-sweetalert2";

import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";
import customParseFormat from "dayjs/plugin/customParseFormat";
import { useNavigate, useParams } from "react-router-dom";

dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.extend(customParseFormat);

interface PostData {
  fn: string;
  confirm_reference: string;
  account_type?: string;
}

const appName = process.env.REACT_APP_NAME!;

export default function AccountConfirmation() {
  const [isValidating, setIsValidating] = useState<boolean>(true);
  const [isProcessing, setIsProcessing] = useState<boolean>(false);
  const [contentTemplate, setContentTemplate] = useState<string>("");
  const [swalProps, setSwalProps] = useState<any>({});

  const [accountData, setAccountData] = useState<any>(null);
  const navigate = useNavigate();
  const { token } = useParams();

  useEffect(() => {
    const initialize = async () => {
      document.title = "Account Confirmation";

      const appleTitle = document.querySelector("meta[name='apple-mobile-web-app-title']");
      if (appleTitle) appleTitle.setAttribute("content", appName);

      const element = document.querySelector('.relative.float-right.h-full.min-h-screen.w-full.bg-darkPrimary');
      if (element) {
        element.classList.replace('bg-darkPrimary', 'bg-white');
      }

      await validateAccountByToken();
    };

    initialize();

    const handleClickConfirm = () => {
      handleSubmit();
    };

    const handleSelectChange = (event: Event) => {
      const target = event.target as HTMLSelectElement;
      const hiddenInput = document.getElementById('account-type-value') as HTMLInputElement;
      if (hiddenInput) {
        hiddenInput.value = target.value;
      }
    };

    const observer = new MutationObserver(() => {
      const confirmButton = document.getElementById('confirm-btn');
      if (confirmButton) {
        confirmButton.addEventListener('click', handleClickConfirm);
        observer.disconnect();
      }

      const accountTypeSelector = document.getElementById('account-type-selector') as HTMLSelectElement;
      if (accountTypeSelector) {
        accountTypeSelector.addEventListener('change', handleSelectChange);
      }

      if (confirmButton && accountTypeSelector) {
        observer.disconnect();
      }
    });

    observer.observe(document.body, { childList: true, subtree: true });

    return () => {
      observer.disconnect();
    };
  }, []);

  const validateAccountByToken = async () => {
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}/api/receiveraccount/request`,
        { fn: "validate", confirm_reference: token }
      );

      if (response.data.status === 'ok') {
        if (response.data.data.receiver_account.confirm_status !== 'awaiting') {
          setContentTemplate(response.data.data.html_snippet);
          setIsValidating(false);
          setAccountData(response.data.data);
        } else {
          navigateToNotFoundPage();
        }
      } else {
        navigateToNotFoundPage();
      }
    } catch (error) {
      navigateToNotFoundPage();
    }
  };

  const handleSubmit = async () => {
    let isValid = true;
    let accountType = "";

    const accountTypeSelector = document.getElementById('account-type-selector') as HTMLSelectElement;
    const accountTypeInputHidden = (document.getElementById('account-type-value') as HTMLInputElement);

    if (accountTypeInputHidden) {
      accountType = accountTypeInputHidden.value
    }

    if (accountTypeSelector && accountType === "") {
      isValid = false;
      setSwalProps({
        show: true,
        icon: "error",
        title: "Oops!",
        html: "Please select your account type before continue",
        showConfirmButton: true,
        didClose: () => {
          setSwalProps({});
          setIsProcessing(false);
        }
      });
    }

    if (isValid) {
      setIsProcessing(true);
      try {
        const postData: PostData = {
          fn: "confirm",
          confirm_reference: token
        }

        if (accountTypeSelector) {
          postData.account_type = accountType;
        }

        const response = await axios.post(`${process.env.REACT_APP_API_URL}/api/receiveraccount/request`, postData);

        if (response.data.status === 'ok') {
          setIsProcessing(false);
          setContentTemplate(response.data.html_snippet);
        } else {
          setIsProcessing(false);
          navigateToErrorPage();
        }
      } catch (error) {
        navigateToErrorPage();
      }
    }
  };

  const navigateToNotFoundPage = async () => {
    navigate(`/404`);
  };

  const navigateToErrorPage = async () => {
    navigate(`/500`);
  };

  return (
    <>
      {(isValidating || isProcessing || accountData === null) &&
        <div className="flex items-center justify-center h-screen">
          <ImSpinner8 className="spinner" style={{ fontSize: '2rem' }} />
        </div>
      }
      {!isValidating && !isProcessing && accountData !== null &&
        <div className="mb-auto flex flex-col items-center justify-center md:pr-0 lg:pl-0 xl:max-w-full">
          <input type="hidden" id="account-type-value" name="accountType" />
          <div className="mb-16 mt-4 flex h-full w-full items-center justify-center px-2 md:mx-0 md:px-0 lg:mb-10 lg:items-center">
            <div dangerouslySetInnerHTML={{ __html: contentTemplate }} />
          </div>
        </div>
      }
      <SweetAlert2 {...swalProps} customClass={{ actions: 'custom-swal2-popup-action', title: 'custom-swal2-popup-title', confirmButton: 'custom-swal2-popup-action custom-swal2-popup-action-confirm', cancelButton: 'custom-swal2-popup-action custom-swal2-popup-action-cancel' }}>
      </SweetAlert2>
    </>
  );
}
